import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/tailwind.css'
import VModal from 'vue-js-modal'

Vue.config.productionTip = false
Vue.use(VModal)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// window.addEventListener("beforeunload", function(event) {
//   console.log('cerrado')
//   // debugger
//   event.returnValue = "cerrado";
//   return 'Sure?'
// });


// window. onbeforeunload = function(event) {
//   return 'seguro?'
//   window.localStorage.clear();
  
// };